module.exports = __webpack_public_path__ + "resources/images/pinpas-bf0af4095819581bf81305f66a553998-cache.jpg";